import React, { useEffect, useRef, useState } from 'react';
import { collection, query, where, getDocs, onSnapshot, deleteDoc, doc, getDoc } from "firebase/firestore";
import { useDispatch, useSelector } from 'react-redux';
import { Table, Card, CardBody, Row, Spinner, Toast, ToastBody, ToastHeader } from 'reactstrap';
import { fetchOpenPositions, selectOpenPositions, addPosition, removePosition } from '../../../rtk/slices/openPositionsSlice/openPositionsSlice';
import { setTP } from '../../../rtk/slices/openPositionsSlice/openPositionsSlice';
import { selectAccountDetails } from '../../../rtk/slices/account-detail/accountDetailSlice';
import { selectSymbols } from '../../../rtk/slices/tradingSlice/tradingSlice';
import { useLocation } from 'react-router-dom';
import UserCheckModal from '../UserCheckModal';
import { calculateProfitMargin, handleCancelEdit, handleEditStart, handleOrderClose, handleUpdateSL, handleUpdateTP } from './funtions';
import OrderActions from './OrderActions';

import { db } from '../../../firebase';


const OpenPositions = () => {

  const location = useLocation();
  const dispatch = useDispatch();
  // const { positions } = useSelector(selectOpenPositions);
  const [positions, setPositions] = useState([]);
  const { loading, error } = useSelector((state) => state.openPositions);
  const account = JSON.parse(localStorage.getItem("user"));
  const autoCloseTriggered = useRef(false);
  // const account = user?.account;
  // const { account } = useSelector(selectAccountDetails);
  const symbols = useSelector(selectSymbols);

  // console.log('symbols', symbols);


  const path = location.pathname;
  const currentPath = path === '/open-position'

  const [calculatedProfits, setCalculatedProfits] = useState({});
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalMargin, setTotalMargin] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [editingField, setEditingField] = useState(null); // To track which field is being edited
  const [editValue, setEditValue] = useState('');

  // console.log('calculatedProfits',calculatedProfits)

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const accountNum = user?.account;

    if (!accountNum) return;

    const tradesRef = collection(db, "trades_collection");
    const q = query(tradesRef,
      where("account", "==", accountNum),
      where("status", "==", "active") // 👈 only active trades
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const trades = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("Real-time trades:", trades);
      setPositions(trades);
    });

    // Clean up listener on component unmount
    return () => unsubscribe();
  }, []);


  //  useEffect(() => {
  //     const user = JSON.parse(localStorage.getItem('user'));
  //     const accountNum = user ? user.account : null;

  //     if (accountNum) {

  //       dispatch(fetchAccountDetails(accountNum));
  //       dispatch(fetchOpenPositions(accountNum));

  //       connectToTradeSocket(accountNum, (deal) => {
  //         if (deal.currentPrice > 0) {
  //           dispatch(removePosition(deal.position_id));
  //           console.log(`removed order ${deal.position_id} from websocket`);

  //         } else {
  //           const newPosition = {
  //             position_id: deal.position_id,
  //             symbol: deal.symbol,
  //             volume: deal.lotsize,
  //             type: deal.action === "1" ? "SELL" : deal.action==="0"? "BUY" : "",
  //             price: deal.price,
  //             commission: deal.commssion,
  //             reason: deal.reason,
  //             profit: deal.profit,
  //             currentPrice: deal.currentPrice,
  //             sl: deal.SL,
  //             tp: deal.TP,
  //             open_time_formated: new Date(deal.opentime * 1000).toLocaleString(), // adjust if needed
  //           };
  //           dispatch(addPosition(newPosition));
  //           console.log(`added order ${deal.position_id} from websocket`);
  //         }
  //       });

  //       return () => {
  //         disconnectFromTradeSocket();
  //       };
  //     }
  //   }, [dispatch]);



  useEffect(() => {
    calculateProfitMargin(positions, symbols, setCalculatedProfits, setTotalProfit, setTotalMargin, dispatch, setTP, totalProfit);
  }, [positions, symbols]);

  // const marginLevel = ((account.balance + totalProfit) / totalMargin) * 100;
  // console.log(`Margin Level = ${marginLevel.toFixed(2)}%`);


  // useEffect(() => {
  //   console.log("🔥 Auto-close check triggered");

  //   if (
  //     typeof marginLevel !== 'number' ||
  //     isNaN(marginLevel) ||
  //     autoCloseTriggered.current ||
  //     positions.length === 0
  //   ) return;

  //   if (marginLevel < 50) {
  //     const sortedPositions = [...positions].sort((a, b) => {
  //       const profitA = calculatedProfits[a.position_id] || 0;
  //       const profitB = calculatedProfits[b.position_id] || 0;
  //       return profitA - profitB;
  //     });

  //     const positionToClose = sortedPositions[0];

  //     if (positionToClose) {
  //       console.log("🧨 Auto-close target:", positionToClose);
  //       autoCloseTriggered.current = true;
  //       handleOrderClose(positionToClose, setToastMessage, setShowToast);

  //       setTimeout(() => {
  //         autoCloseTriggered.current = false;
  //       }, 3000);
  //     }
  //   }
  // }, [marginLevel, positions, calculatedProfits]);




  return (
    <div className={currentPath ? 'page-content py-0 pe-0' : null}>
      <Card className='mb-0'>
        <CardBody className="p-0">
          <Table className={currentPath ? 'text-center' : 'text-center trading-t-table'}>
            <thead className="trading-theaders bg-body">
              <tr>
                <th>Symbol</th>
                <th>Pos. ID</th>
                <th>Open Time</th>
                <th>Type</th>
                <th>Volume</th>
                <th>Price</th>
                <th>SL</th>
                <th>TP</th>
                <th>Current Price</th>
                <th>Profit</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody  >
              {

                loading ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      <Spinner size="sm" color="primary" /> Loading...
                    </td>
                  </tr>
                )
                  :
                  error ? (
                    // Render error row if there's an error
                    <tr>
                      <td colSpan="11" className="text-center text-danger">
                        {" Page you are looking for doesn't exit or an other error ocurred or temporarily unavailable."}
                        {" Please try again."}
                      </td>
                    </tr>
                  )
                    :
                    positions?.length > 0 ? positions.map((position) => {
                      // Clean the symbol name for lookup
                      // const cleanSymbol = position.symbol.split('.')[0].split('ex')[0]; // removes . or .ex1
                      const symbolData = symbols[position?.symbol];

                      const currentPrice = position.type === 'BUY' ? symbolData?.bid : symbolData?.ask;
                      const profit = calculatedProfits[position.position_id] || 0;
                      // const currentPrice = symbols[position.symbol]?.[position.type === 'buy' ? 'bid' : 'ask'] || 'Loading...';

                      const defaultSL = position.sl === 0 ? 0 : position.sl;
                      const defaultTP = position.tp === 0 ? 0 : position.tp;

                      return (
                        <tr className='opd-tr' key={position.position_id}
                        // onContextMenu={(e) => handleRightClick(e, position)}
                        >
                          <td>{position.symbol}</td>
                          <td>{position.position_id}</td>
                          <td>{position.timestamp}</td>
                          <td>
                            <span
                              className={`badge cursor-pointer ${position.type === 'SELL' ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'
                                }`}
                            >
                              {position.type.toLowerCase()}
                            </span>
                          </td>
                          <td
                            className={`${position.type === 'SELL' ? 'text-primary' : 'text-secondary'
                              }`}
                          >{position.volume}</td>
                          <td>{Number(position.price).toFixed(2)}</td>
                          {/* SL Field */}
                          <td
                            onMouseEnter={() => { }}
                            onMouseLeave={() => { }}
                          >
                            {editingField?.position_id === position.position_id && editingField?.field === 'sl' ? (
                              <>
                                <input
                                  type="number"
                                  className="form-control py-0 px-1"
                                  value={editValue}
                                  onChange={(e) => setEditValue(e.target.value)}
                                  style={{ width: '80px', display: 'inline' }}
                                  autoFocus
                                />
                                <i
                                  className="ri-check-line text-success ms-2 cursor-pointer"
                                  onClick={() => handleUpdateSL(position, position.position_id, editValue, setEditingField, dispatch)}
                                ></i>
                                <i
                                  className="ri-close-line text-danger ms-2 cursor-pointer"
                                  onClick={handleCancelEdit(setEditingField, setEditValue)}
                                ></i>
                              </>
                            ) : (
                              <>
                                {defaultSL === 0 ? '0' : defaultSL}
                                <i
                                  className="ri-edit-line ms-2 cursor-pointer"
                                  onClick={() => handleEditStart(position.position_id, 'sl', currentPrice, setEditingField, setEditValue)}
                                ></i>
                              </>
                            )}
                          </td>
                          {/* TP Field */}
                          <td>
                            {editingField?.position_id === position.position_id && editingField?.field === 'tp' ? (
                              <>
                                <input
                                  type="number"
                                  className="form-control py-0 px-0"
                                  value={editValue}
                                  onChange={(e) => setEditValue(e.target.value)}
                                  style={{ width: '80px', display: 'inline' }}
                                  autoFocus
                                />
                                <i
                                  className="ri-check-line text-success ms-2 cursor-pointer"
                                  onClick={() => handleUpdateTP(position, position.position_id, editValue, setEditingField, dispatch)}
                                ></i>
                                <i
                                  className="ri-close-line text-danger ms-2 cursor-pointer"
                                  onClick={handleCancelEdit(setEditingField, setEditValue)}
                                ></i>
                              </>
                            ) : (
                              <>
                                {defaultTP === 0 ? '0' : defaultTP}
                                <i
                                  className="ri-edit-line ms-2 cursor-pointer"
                                  onClick={() => handleEditStart(position.position_id, 'tp', currentPrice, setEditingField, setEditValue)}
                                ></i>
                              </>
                            )}
                          </td>
                          <td className={
                            currentPrice < position.price ? "text-primary" : "text-secondary"
                          }>{currentPrice}</td>
                          <td style={{ color: profit <= 0 ? "#DC3A48" : "#3577f1" }}>{profit}</td>
                          {/* <td style={{ color: position.profit <= 0 ? "#DC3A48" : "#3577f1" }}>{position.profit}</td> */}
                          <td style={{ textAlign: "center", display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center' }}>
                            <span onClick={() => handleOrderClose(position, setToastMessage, setShowToast)}
                              className="bg-primary cursor-pointer"
                              style={{ color: "white", padding: "0px 3px", borderRadius: "50%", fontSize: "13px" }}>
                              <i className="ri-close-line"></i>
                            </span>
                            <OrderActions positions={positions} position={position} />
                          </td>

                        </tr>
                      );
                    }) : (
                      <tr>
                        <td colSpan="11" style={{ textAlign: 'center' }}>No open positions available</td>
                      </tr>
                    )}
            </tbody>
          </Table>

          {
            !currentPath ? <>
              {account && (
                <div className='d-flex align-items-center bg-body trading-t-footer' >
                  <p className='mb-0'>
                    <strong>Balance:</strong> {Number(account.balance).toFixed(2)}
                    &nbsp;&nbsp;&nbsp;

                    <strong>Equity:</strong> {(account.balance + totalProfit).toFixed(2)}
                    &nbsp;&nbsp;&nbsp;

                    {positions?.length > 0 && (
                      <>
                        <strong>Margin:</strong> {totalMargin.toFixed(2)}
                        &nbsp;&nbsp;&nbsp;

                        <strong>Margin Level (%):</strong> {((account.balance + totalProfit) / totalMargin * 100).toFixed(2)}%
                        &nbsp;&nbsp;&nbsp;
                      </>
                    )}


                    <strong
                    >
                      Free Margin:</strong> <span
                        style={{ color: (account.balance + totalProfit - totalMargin) < 0 ? "#DC3A48" : "#3577f1" }}
                      > {(account.balance + totalProfit - totalMargin).toFixed(2)}</span>
                  </p>
                </div>

              )}
            </>
              :
              <>
                {/* <UserCheckModal message="To view you orders list, please select your trading account first." /> */}
                {account && (
                  <>
                    <Row className="justify-content-between account-op-cards-row px-2">
                      <Card style={{ width: '15%', border: '1px solid #494848' }}>
                        <CardBody className='text-center p-1'>
                          <h4 style={{ fontSize: '100%' }}>Balance</h4>
                          <p className='mb-0'> {Number(account.balance).toFixed(2)}  </p>
                        </CardBody>
                      </Card>
                      <Card style={{ width: '15%', border: '1px solid #494848' }}>
                        <CardBody className='text-center p-1'>
                          <h4 style={{ fontSize: '100%' }}>Equity</h4>
                          <p className='mb-0'> {(account.balance + totalProfit).toFixed(2)}</p>
                        </CardBody>
                      </Card>

                      {positions?.length > 0 && (
                        <>
                          <Card style={{ width: '15%', border: '1px solid #494848' }}>
                            <CardBody className='text-center p-1'>
                              <h4 style={{ fontSize: '100%' }}>Margin</h4>
                              <p className='mb-0'>{totalMargin.toFixed(2)}</p>
                            </CardBody>
                          </Card>
                          <Card style={{ width: '15%', border: '1px solid #494848' }}>
                            <CardBody className='text-center p-1'>
                              <h4 style={{ fontSize: '100%' }}>Margin Level</h4>
                              <p className='mb-0'>{((account.balance + totalProfit) / totalMargin * 100).toFixed(2)}%</p>
                            </CardBody>
                          </Card>
                        </>
                      )}

                      <Card style={{ width: '15%', border: '1px solid #494848' }}>
                        <CardBody className='text-center p-1'>
                          <h4 style={{ fontSize: '100%' }}>Free Margin</h4>
                          <p style={{ color: (account.balance + totalProfit - totalMargin) < 0 ? "#DC3A48" : "#ffffff" }} className='mb-0'>{(account.balance + totalProfit - totalMargin).toFixed(2)}</p>
                        </CardBody>
                      </Card>
                    </Row>
                  </>
                )}
              </>
          }


        </CardBody>
      </Card>
      <Toast isOpen={showToast} className="position-fixed top-0 end-0 m-3" style={{ zIndex: 9999 }}>
        <ToastHeader icon="success" toggle={() => setShowToast(false)}>
          Success
        </ToastHeader>
        <ToastBody>{toastMessage}</ToastBody>
      </Toast>
    </div >
  );
};

export default OpenPositions;
